import configureStore from './configureStore';
import { persistStore } from 'redux-persist';
import createFilter from 'redux-persist-transform-filter';

const store = configureStore();
const appFilter = createFilter(
    'app',
    ['cloneCreation', 'imageCreation', 'shouldShowGettingStarted']
);
store.hydrated = false;
persistStore(
    store,
    {
        whitelist: ['app'],
        transforms: [appFilter]
    },
    () => {
        store.hydrated = true;
    });

export default store;



// WEBPACK FOOTER //
// ./src/js/store/index.js